export const MESSAGE_UNEXPECTED_ERROR = 'There was an unexpected error. Please try again.'
export const PLAN_PRICE = {
  quarterly: 89.95,
  annually: 339.95,
  alltruePlus: 319.8,
  artisanCrafted: 74.95,
  wearables: 74.95,
  ultracleanBeauty: 74.95,
}
